<template>
<section class="documents-list-container">

    <div class="documents-list__header">
      <button @click="createDocument" class="action-btn add-btn">Create Document</button>
    </div>

  <div class="documents-list">


    <div class="documents-list__item" v-for="document in documentsModel" :key="document.id">
      <h3 class="documents-list__item-title">{{ document.attributes.documentTitle }}</h3>
    <button class="draggable-item__action" type="button" @click="editDocument(document.id)">
        <v-icon>edit</v-icon>
      </button>
  </div>
  </div>
  <div class="pagination">
      <v-pagination
        v-model="pageNumber"
        :length="Math.ceil(total / pageSize)"
        :total-visible="10"
        circle
        color="accent">
      </v-pagination>
    </div>
</section>
</template>

<script>
import { useDocuments } from "../../composables/useDocuments";
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "DocumentsList",

  methods: {
    createDocument() {
      const newId = this.$uuid.v1()
      this.$router.push(`/document/${newId}`)
      this.$store.commit("openCreateNewDocument");
      this.$store.commit("setEmptyDocument")
    }
  },

  setup() {
    const { fetchDocuments, documentsModel, total } = useDocuments();
    const pageSize = ref(10);
    const pageNumber = ref(1);
    fetchDocumentsList()

    async function fetchDocumentsList() {
      await fetchDocuments(pageSize.value, pageNumber.value);
    }

    function editDocument(id) {
      this.$router.push(`/document/${id}`);
    }


    return {
      fetchDocuments,
      documentsModel,
      fetchDocumentsList,
      pageSize,
      pageNumber,
      editDocument,
      total
    }
  },

  watch: {
    pageNumber(value, oldValue) {
      if (oldValue) {
        this.fetchDocumentsList()
      }
    },
  },

})
</script>

<style scoped lang="scss">
.documents-list {

  &__item-title {
    font-weight: 400;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    padding: 20px;
    position: relative;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    margin-top: 16px;
  }

  &-container {
    padding: 0 56px;
  }

  &-container__title {
    font-size: 24px;
    font-weight: 600;
    margin: 16px 0;
  }

  &__header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.action-btn {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin: 16px 0 0 0;
  font-size: 14px;
}


.edit-btn {
  display: flex;
  gap: 4px;
  border: none;
  border-radius: 3px;
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: white;
  border: 1px solid #ccc;
  color: #ccc;
}
</style>
